import styled from 'styled-components';

import { colors } from '../../WindowConfig';

const DataCell = styled.div<any>`
  border-top: solid 1px ${colors.border};
  text-transform: uppercase;
  ${({ padding = '0 0 0 0' }) => {
    return `padding: ${padding}`;
  }};
  ${({ width = 'auto' }) => {
    return `width: ${width}`;
  }};
  ${({ height = 'auto' }) => {
    return `height: ${height}`;
  }};
  ${({ margin = '0 0 0 0' }) => {
    return `margin: ${margin}`;
  }};
  ${({ minHeight = '20px' }) => {
    return `min-height: ${minHeight}`;
  }};
  ${({ backgroundColor = colors.secondary }) => {
    return `background-color: ${backgroundColor}`;
  }};
  ${({ color = colors.white }) => {
    return `color: ${color}`;
  }};
`;
export default DataCell;
